import {
    Column,
    Entity,
    ManyToMany,
    ManyToOne,
    PrimaryGeneratedColumn,
} from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IInstallation } from './interface/IInstallation';
import { IRefInstallation } from './interface/IRefInstallation';
import { IRefInstallationCategory } from './interface/IRefInstallationCategory';

@Entity('ref_installation')
export class RefInstallation extends BaseEntity implements IRefInstallation {
    apiMapping = {
        refInstallationId: 'id',
        name: 'name',
        refInstallationCategoryId: {
            fieldName: 'refInstallationCategory',
            type: 'RefInstallationCategory',
        },
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @Column({ nullable: true })
    isDeleted: boolean;

    @ManyToMany('Installation', 'refInstallations')
    installations: IInstallation[];

    @ManyToOne('RefInstallationCategory')
    refInstallationCategory: IRefInstallationCategory;
}
